import { render, staticRenderFns } from "./Gcolumn.vue?vue&type=template&id=654c0353&scoped=true&"
import script from "./Gcolumn.vue?vue&type=script&lang=ts&"
export * from "./Gcolumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c0353",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654c0353')) {
      api.createRecord('654c0353', component.options)
    } else {
      api.reload('654c0353', component.options)
    }
    module.hot.accept("./Gcolumn.vue?vue&type=template&id=654c0353&scoped=true&", function () {
      api.rerender('654c0353', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/Gcolumn.vue"
export default component.exports